// 地図キャンバスのスクリーンショット取得（ブラウザ専用の薄いユーティリティ）。
//
// 役割: deck.gl が描画している canvas（既定 id は deckgl-overlay）から JPEG の base64 を取り出す。
//       OSM ベースマップもデータレイヤーも同じ canvas に描かれるため、1 枚で地図全体が入る。
//       luma.gl 9 は preserveDrawingBuffer が既定 true なので、描画直後でなくても読み出せる。
// 関係: useVoiceSession が capture_map ツールの実装として呼び、Gemini Live へ画像として送る。
//       download.js と同じ「DOM に触れる薄いユーティリティ」の位置づけで、UI/フックからのみ呼ぶ。

export const MAP_CANVAS_ID = 'deckgl-overlay'

// 送信サイズを抑えるための最大幅。地図の文字が読める程度は残す。
const DEFAULT_MAX_WIDTH = 1024
// タイル読み込みやカメラ遷移（fitToBounds の transitionDuration: 500）の途中を避けるための待ち。
const DEFAULT_SETTLE_MS = 600

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

// 現在の地図を JPEG の base64 で返す。
export async function captureMapImage({
  canvasId = MAP_CANVAS_ID,
  maxWidth = DEFAULT_MAX_WIDTH,
  quality = 0.75,
  settleMs = DEFAULT_SETTLE_MS,
} = {}) {
  const canvas = document.getElementById(canvasId)
  if (!canvas) throw new Error('地図キャンバスが見つかりませんでした。')
  if (settleMs > 0) await delay(settleMs)

  const width = canvas.width
  const height = canvas.height
  if (!width || !height) throw new Error('地図がまだ描画されていません。')

  let dataUrl
  if (width > maxWidth) {
    // 大きすぎる場合は 2D キャンバスへ縮小コピーしてから書き出す。
    const scale = maxWidth / width
    const scaled = document.createElement('canvas')
    scaled.width = Math.round(width * scale)
    scaled.height = Math.round(height * scale)
    const ctx = scaled.getContext('2d')
    // JPEG は透過を扱えないため下地を白で塗る。
    ctx.fillStyle = '#ffffff'
    ctx.fillRect(0, 0, scaled.width, scaled.height)
    ctx.drawImage(canvas, 0, 0, scaled.width, scaled.height)
    dataUrl = scaled.toDataURL('image/jpeg', quality)
  } else {
    dataUrl = canvas.toDataURL('image/jpeg', quality)
  }

  const base64 = dataUrl.split(',')[1]
  if (!base64) throw new Error('地図画像の取得に失敗しました。')
  return { base64, mimeType: 'image/jpeg', width, height }
}
